export default __webpack_public_path__ + "static/media/logo_blue.46799ff9.svg";